{
  "actions": {
    "apply": "Apply",
    "approve": "Approve",
    "back": "Back",
    "cancel": "Cancel",
    "close": "Close",
    "create": "Create",
    "delete": "Delete",
    "deleting": "Deleting…",
    "edit": "Edit",
    "next": "Next",
    "previous": "Previous",
    "refresh": "Refresh",
    "reject": "Reject",
    "remove": "Remove",
    "retry": "Retry",
    "save": "Save",
    "saveChanges": "Save changes",
    "saving": "Saving…",
    "send": "Send",
    "sending": "Sending…",
    "submitting": "Submitting…",
    "update": "Update",
    "upload": "Upload",
    "uploading": "Uploading…",
    "view": "View",
    "viewDetails": "View details"
  },
  "states": {
    "loading": "Loading…",
    "none": "None",
    "notAvailable": "N/A",
    "unknown": "Unknown"
  },
  "labels": {
    "yes": "Yes",
    "no": "No",
    "optional": "(optional)",
    "all": "All",
    "status": "Status",
    "actions": "Actions",
    "date": "Date",
    "name": "Name",
    "email": "Email",
    "description": "Description"
  },
  "errors": {
    "generic": "Something went wrong. Please try again.",
    "network": "Could not reach the server. Check your connection and try again.",
    "server": "Something went wrong on our side. Please try again later.",
    "companyNotApproved": "Your company must be approved before you can manage this resource."
  },
  "language": {
    "label": "Language"
  },
  "apiFallback": {
    "documentUploadFailed": "Document upload failed. Please try again.",
    "failedToAddDocument": "Failed to add document.",
    "failedToAddEntity": "Failed to add entity.",
    "failedToAddShareholder": "Failed to add shareholder.",
    "failedToCreateConversation": "Failed to create conversation.",
    "failedToDeleteDocument": "Failed to delete document.",
    "failedToDeleteEntity": "Failed to delete entity.",
    "failedToDeleteProduct": "Failed to delete product. Please try again.",
    "failedToDeleteService": "Failed to delete service. Please try again.",
    "failedToDeleteShareholder": "Failed to delete shareholder.",
    "failedToLoadArticles": "Failed to load articles.",
    "failedToLoadConversation": "Failed to load conversation.",
    "failedToLoadConversations": "Failed to load conversations.",
    "failedToLoadDocuments": "Failed to load documents.",
    "failedToLoadEntityRegistrations": "Failed to load entity registrations.",
    "failedToLoadMatchResults": "Failed to load match results.",
    "failedToLoadMessages": "Failed to load messages.",
    "failedToLoadModerator": "Failed to load moderator.",
    "failedToLoadProducts": "Failed to load products. Please try again.",
    "failedToLoadProfile": "Failed to load profile. Please try again.",
    "failedToLoadRequests": "Failed to load requests. Please try again.",
    "failedToLoadServices": "Failed to load services. Please try again.",
    "failedToLoadShareholders": "Failed to load shareholders.",
    "failedToMarkAsRead": "Failed to mark as read.",
    "failedToSendMessage": "Failed to send message.",
    "failedToUpdateEntity": "Failed to update entity.",
    "failedToUpdateShareholder": "Failed to update shareholder.",
    "fileUploadFailed": "File upload failed. Please try again.",
    "invalidCode": "Invalid code.",
    "invalidEmailOrPassword": "Invalid email or password.",
    "productCreationFailed": "Product creation failed. Please try again.",
    "productUpdateFailed": "Product update failed. Please try again.",
    "profileUpdateFailed": "Profile update failed. Please try again.",
    "registrationFailed": "Registration failed. Please try again.",
    "requestCreationFailed": "Request creation failed. Please try again.",
    "serviceCreationFailed": "Service creation failed. Please try again.",
    "serviceUpdateFailed": "Service update failed. Please try again.",
    "wrongEmailOrPassword": "Wrong email or password."
  }
}
